import { Button, Stack } from '@mui/material';
import React from 'react';
import { HandleSubmitGroupView } from '../../CommonComponents/GroupedView/Functions/HandleSubmitGroupView';
import { SaveElectronicForm } from 'Routes/Protected/AddNewMedicalForm/Adapters/SaveElectronicForm';
import SwalAlert from '../../CommonComponents/SwalAlert/SwalAlert';
import { useContext } from 'react';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import AccessControl from 'Global/security/AccessControl';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const EditAddOrCancelForm = ({
  StateBank,
  getValues,
  reset,
  fieldArrayName,
  fetchedFrom,
  liftState,
  surveyDisable,
}) => {
  const GlobalConstants = useContext(GlobalContext);
  const editMsg = FindLangKey(
    'edit-medical-font-alert-save-sure'
  );
  const save_msg_survey = FindLangKey(
    'general-public-add-form-sure'
  );

  // console.log('surveyDisable-->', surveyDisable);

  return (
    <React.Fragment>
      <Stack direction="row-reverse" spacing={1}>
        {surveyDisable !== null && surveyDisable ? (
          <></>
        ) : (
          <Button
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
            }}
            disabled={
              surveyDisable !== null
                ? !!surveyDisable
                : AccessControl(
                    'edit-medical-form-action-edit-form'
                  )
            }
            color="colorPrimer"
            variant="contained"
            fullWidth
            onClick={() => {
              const values = getValues();

              SwalAlert(
                'warning',
                surveyDisable !== null && !surveyDisable
                  ? save_msg_survey
                  : editMsg,
                true,
                () => {
                  if (liftState) {
                    liftState(
                      HandleSubmitGroupView(
                        values?.MedicalDefaultValues
                      ),
                      {
                        idElsFormPatient:
                          fetchedFrom?.IdReport,
                        formID: StateBank.formId,
                        idCartablPatient:
                          StateBank.IdCartablePatient,
                        navigate: GlobalConstants.navigate,
                      },
                      reset,
                      fieldArrayName,
                      StateBank,
                      surveyDisable
                    );
                    return;
                  }
                  SaveElectronicForm(
                    HandleSubmitGroupView(
                      values?.MedicalDefaultValues
                    ),
                    {
                      idElsFormPatient:
                        fetchedFrom?.IdReport,
                      formID: StateBank.formId,
                      idCartablPatient:
                        StateBank.IdCartablePatient,
                      navigate: GlobalConstants.navigate,
                    },
                    reset,
                    fieldArrayName,
                    StateBank,
                    surveyDisable
                  );
                }
              );
            }}
          >
            {FindLangKey('general-public-btn-save')}
          </Button>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default EditAddOrCancelForm;
